import { render } from "./ContentTagSelect.vue?vue&type=template&id=0285de2d&scoped=true"
import script from "./ContentTagSelect.vue?vue&type=script&lang=js"
export * from "./ContentTagSelect.vue?vue&type=script&lang=js"

import "./ContentTagSelect.vue?vue&type=style&index=0&id=0285de2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0285de2d"]])

export default __exports__